// extracted by mini-css-extract-plugin
export default {"root":"IconMasterCard_root__cwtrw"};